// extracted by mini-css-extract-plugin
export default {"ProductList":"ProductList_ProductList__LGRnp","flex5":"ProductList_flex5__y+lG0"};